import * as firebase from 'firebase/app';
import { COLLECTION_USERS } from './AppConstants';

export default class FirebaseUtil {
  static ObjectToRef(colle: any, id: string): any {
    return firebase.firestore().doc(`/${colle}/${id}`);
  }
}
